<script>
import {dateFormatReadable, timeFormatReadable, money_format} from "@/utils.js";
export default {
  name: "transactions-table",
  props: ["item"],
  data() {
    return {
      headers: [
        {
          text: "Location",
          align: "start",
          sortable: true,
          value: "location_address"
        },
        { text: "Revenue Center", value: "revenue_center_name", sortable: true },
        { text: "Date", value: "transaction_time", sortable: true },
        { text: "Amount Spent", value: "transaction_amount", sortable: true },
        { text: "Campaign Attributed", value: "campaign_attributed" },
        // { text: "", value: "data-table-expand" }
      ],
      dateFormatReadable,
      timeFormatReadable,
      money_format
    };
  }
};
</script>

<template>
  <v-data-table
    hide-default-footer
    disable-pagination
    show-expand
    :headers="headers"
    :items="item"
    item-key="customeId"
    class="transaction-table table table-head-custom table-head-bg table-borderless table-vertical-center elevation-1"
  >
    <template v-slot:item.location="{ item }">
      <div class="d-flex align-items-center">
        <div class="mr-4 ml-4">
          <i class="flaticon-squares-1 icon-xl text-primary"></i>
        </div>
        <div>
          <a
            href="#"
            class="text-dark-75 font-weight-bolder text-hover-primary mb-1 font-size-lg"
            >{{ item.location_address ? item.location_address : "~" }}</a
          >
          <!-- <span class="text-muted font-weight-bold d-block">Address:</span> -->
        </div>
      </div>
    </template>
    <template v-slot:item.revenue_center_name="{ item }">
      <span class="text-dark-75 font-weight-bolder d-block font-size-lg">{{
        item.revenue_center_name ? item.revenue_center_name : "~"
      }}</span>
      <span class="text-muted font-weight-bold">status</span>
    </template>
    <template v-slot:item.transaction_time="{ item }">
      <span class="text-dark-75 font-weight-bolder d-block font-size-lg">{{
        dateFormatReadable(item.transaction_time)
      }}</span>
      <span class="text-muted font-weight-bold">{{
        timeFormatReadable(item.transaction_time)
      }}</span>
    </template>
    <template v-slot:item.transaction_amount="{ item }">
      <span class="text-dark-75 font-weight-bolder d-block font-size-lg">{{
        money_format(item.transaction_amount)
      }}</span>
      <span class="text-muted font-weight-bold">Paid</span>
    </template>
    <template v-slot:item.campaign_attributed="{ item }">
      <span class="text-muted font-weight-bold d-block font-size-sm">{{
        item.campaign_attributed ? "YES" : "NO"
      }}</span>
    </template>
    <template v-slot:expanded-item="{ headers, item }">
      <td :colspan="headers.length" class="profile-transaction">
        <span
          v-for="perItem in item.check_items" :key="perItem.invoice_no"
          :class="`rounded-xl subtitle-1 blue accent-1 white--text inline-block`"
          class="px-4 py-1 mr-4 text-center secondary text-no-wrap "
          v-text="perItem.description + ' ' + (perItem.quantity == 1 ? '' : '(' +perItem.quantity+')')"
        ></span>
      </td>
    </template>
  </v-data-table>
</template>

<style scope>
  .transaction-table tr.v-data-table__expanded.v-data-table__expanded__content {
    box-shadow: none !important;
  }
  td.profile-transaction span{
    display: inline-block;
    margin: 5px 0;
  }
</style>
